// Map statTableId values:
// 0 - General/common stats
// 1 - Batting stats
// 2 - Pitching stats
// 3 - Fielding stats

export const STATS_CONFIG = {
  batting: {
    id: 'battingStats',
    label: 'Batting',
    tableId: 1,
    columns: [
      { accessor: 'year', header: 'Year', statTableId: 0 },
      { accessor: 'gamesPlayed', header: 'GP', statTableId: 1 },
      { accessor: 'gamesStarted', header: 'GS', statTableId: 1 },
      { accessor: 'atBat', header: 'AB', statTableId: 1 },
      { accessor: 'runs', header: 'R', statTableId: 1 },
      { accessor: 'hits', header: 'H', statTableId: 1 },
      { accessor: 'doubles', header: '2B', statTableId: 1 },
      { accessor: 'triples', header: '3B', statTableId: 1 },
      { accessor: 'homeRuns', header: 'HR', statTableId: 1 },
      { accessor: 'runsBattedIn', header: 'RBI', statTableId: 1 },
      { accessor: 'baseonBalls', header: 'BB', statTableId: 1 },
      { accessor: 'hitByPitch', header: 'HBP', statTableId: 1 },
      { accessor: 'strikeOuts', header: 'SO', statTableId: 1 },
      { accessor: 'battingAverage', header: 'AVG', statTableId: 1 },
      { accessor: 'onBasePercentage', header: 'OBP', statTableId: 1 },
      { accessor: 'totalBases', header: 'TB', statTableId: 1 },
      { accessor: 'sacrificeFly', header: 'SF', statTableId: 1 },
      { accessor: 'sacrificeHit', header: 'SH', statTableId: 1 },
      // { accessor: 'stolenBasesStolenBasesAttempts', header: 'SB-ATT' },
      // { accessor: 'gamesPlayedGamesStarted', header: 'GP-GS' },
      { accessor: 'sluggingPercentage', header: 'SLG%', statTableId: 1 },
      { accessor: 'opsPercentage', header: 'OPS', statTableId: 1 },
      { accessor: 'caughtStealing', header: 'CS', statTableId: 1 },
    ],
  },
  fielding: {
    id: 'fieldingStats',
    label: 'Fielding',
    tableId: 3,
    columns: [
      { accessor: 'year', header: 'Year', statTableId: 0 },
      { accessor: 'gamesPlayed', header: 'G', statTableId: 3 },
      { accessor: 'putOuts', header: 'PO', statTableId: 3 },
      { accessor: 'assists', header: 'A', statTableId: 3 },
      { accessor: 'errors', header: 'E', statTableId: 3 },
      { accessor: 'fieldingPercent', header: 'FLD%', statTableId: 3 },
      { accessor: 'doublePlays', header: 'DP', statTableId: 3 },
      { accessor: 'caughtStealing', header: 'CS', statTableId: 3 },
      { accessor: 'caughtStealingPercentage', header: 'CS%', statTableId: 3 },
      { accessor: 'inningsPlayed', header: 'INN', statTableId: 3 },
      { accessor: 'totalChances', header: 'TC', statTableId: 3 },
    ],
  },
  pitching: {
    id: 'pitchingStats',
    label: 'Pitching',
    tableId: 2,
    columns: [
      { accessor: 'year', header: 'Year', statTableId: 0 },
      { accessor: 'winsLosses', header: 'W-L', statTableId: 2 },
      { accessor: 'earnedRunAverage', header: 'ERA', statTableId: 2 },
      { accessor: 'appearances', header: 'G', statTableId: 2 },
      { accessor: 'gamesStarted', header: 'GS', statTableId: 2 },
      { accessor: 'completeGames', header: 'CG', statTableId: 2 },
      { accessor: 'shutout', header: 'SHO', statTableId: 2 },
      { accessor: 'saves', header: 'SV', statTableId: 2 },
      { accessor: 'inningsPitched', header: 'IP', statTableId: 2 },
      { accessor: 'hits', header: 'H', statTableId: 2 },
      { accessor: 'runs', header: 'R', statTableId: 2 },
      { accessor: 'earnedRuns', header: 'ER', statTableId: 2 },
      { accessor: 'homeRuns', header: 'HR', statTableId: 2 },
      { accessor: 'baseOnBalls', header: 'BB', statTableId: 2 },
      { accessor: 'hitByPitch', header: 'HBP', statTableId: 2 },
      { accessor: 'strikeOuts', header: 'SO', statTableId: 2 },
      { accessor: 'numberOfPitches', header: 'NP', statTableId: 2 },
      { accessor: 'balls', header: 'B', statTableId: 2 },
      { accessor: 'strikes', header: 'S', statTableId: 2 },
      { accessor: 'wildPitch', header: 'WP', statTableId: 2 },
      {
        accessor: 'opponentsBattingAverageAgainst',
        header: 'BAA',
        statTableId: 2,
      },
    ],
  },
};
